<template>
  <div v-if="!$store.state.app.isLoadingPage">
    <B2B />
  </div>
</template>

<script>
// eslint-disable-next-line import/no-unresolved
import store from '@/store'
import B2B from './b2b/Crm.vue'

export default {
  components: {
    // eslint-disable-next-line vue/no-unused-components
    B2B,
  },
  data() {
    return {
      perfil: {},
      isLoading: true,
      idCheckout: null,
      transactionID: null,
      formContext: null,
      transactionSignature: null,
      url: null,
      token: null,
      clientID: null,
      terminalID: null,
      merchantTransactionId: null,
      transactionTimestamp: null,
      amount: 10.25,
    }
  },
  mounted() {
    this.perfil = this.$route.params.perfil
    this.cargaPerfil()

    this.$watch(
      () => this.$route.params,
      // eslint-disable-next-line no-unused-vars
      (toParams, previousParams) => {
        // store.state.app.cargandoMenu = true
        this.perfil = toParams.perfil

        // sessionStorage.setItem('perfil', toParams.perfil)
        // store.commit('getPerfilesAuth')
        // setTimeout(() => {
        //   store.state.app.cargandoMenu = false
        //   window.location.reload()
        // }, 800)
      },
    )
  },
  methods: {
    cargaPerfil() {
      // console.log(store.state.app.userProfile)
      setTimeout(() => {
        store.state.app.isLoadingPage = false
      }, 800)
    },
  },
}
</script>
